import { render, staticRenderFns } from "./CityCreate.vue?vue&type=template&id=af8b5c8c&"
import script from "./CityCreate.vue?vue&type=script&lang=js&"
export * from "./CityCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports